import { TiHomeOutline } from 'react-icons/ti'
import homeDoc from './home'

export default {
  ...homeDoc,
  title: 'Non-CBD Home',
  name: 'homeNonCBD',
  icon: TiHomeOutline
}
